/**
 * @returns {Promise<Object>} API response JSON
 */
export async function callWorkflow() {
  // Use fallback if env variable is missing
  const baseUrl = process.env.REACT_APP_API_AP_URL;
  const AP_URL = `${baseUrl.replace(/\/+$/, '')}/workflow`;

  // Use an AbortController to handle timeouts
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 8000); // 8-second timeout
  const readToken = (key) => {
    const raw = localStorage.getItem(key);
    return raw && raw !== "null" && raw !== "undefined" ? raw : null;
  };
  const ap_token = readToken("ap_token");
  const ap_project_id = readToken("projectId");
  const headers = {
    'Content-Type': 'application/json'
  };

  // 3. If a token exists, add the Authorization header
  if (ap_token) {
    headers['Authorization'] = `Bearer ${ap_token}`;
  }

  try {
    const r = await fetch(AP_URL, {
      method: 'POST',
      headers: headers,
      credentials: 'include',
      body: JSON.stringify({ projectId: ap_project_id }),
      signal: controller.signal
    });

    // If the fetch completes successfully, clear the timeout
    clearTimeout(timeoutId);

    // This block runs if the server responds with an error (e.g., 401, 500)
    if (!r.ok) {
      const body = await r.text().catch(() => '');
      throw new Error(`Workflow API failed: ${r.status} ${body}`);
    }

    return r.json(); // returns JSON with "redirectUrl"

  } catch (error) {
    clearTimeout(timeoutId); // Also clear timeout on other errors
    
    // Check if the error was caused by our timeout
    if (error.name === 'AbortError') {
      // Throw your custom message if the request took too long
      throw new Error('Redirecting, this may take a moment...');
    }
    
    // For any other network error, throw the original error
    throw error;
  }
}